import ApolloClient from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { graphQLEndpoint } from 'app/utils/constants';

// By default, this client will send queries to the
//  `/graphql` endpoint on the same host
export default new ApolloClient({
  link: new HttpLink({
    uri: graphQLEndpoint,
  }),
  cache: new InMemoryCache().restore(window.__APOLLO_STATE__),
  reduxRootKey: 'graph',
  dataIdFromObject: o => o.id,
});
